import Map from "../modules/Map";
import $ from "jquery";
import VanillaModal from "vanilla-modal";

export default markers => {
  const handleClick = marker => {
    const infoNode = $(".Home-map-infos");

    $.get(`?view=ajax/drive-preview&id=${marker.id}&link=1`, function(data) {
      infoNode.find(".Home-map-infos-content").html(data);
      infoNode.addClass("active");

      // $("html, body").animate({ scrollTop: $('.Home-map-extra').offset().top }, 1000);

      if ($(".js-confirm-drive").length > 0){
        let modalNode = document.getElementById("modal-confirmDrive");
        if (!modalNode) {
          modalNode = document.createElement("div");
          modalNode.setAttribute("id", "modal-confirmDrive");
          modalNode.style.display = "none";
          document.body.appendChild(modalNode);
        }

        const modal = new VanillaModal({
          onClose: (e) => {
            if (e) modal.destroy();
          },
        });

        $(".js-confirm-drive").on("click", function(e) {
          e.preventDefault();
          var idDealer = $(this).data('id-dealer');

          $.get(`?view=ajax/confirm-drive&id_dealer=${idDealer}`, function(data) {
            modalNode.innerHTML = data;
            modal.open("#modal-confirmDrive");
          });
        });
      }
    });
  };

  return Map("map_canvas", {
    markers,
    click: handleClick
  }).then(map => {
    $("#findLoc").on("click", () => {
      map.geoloc().then(map.findNearest);
    });
    $(".Home-map-infos")
      .find("button")
      .on("click", function() {
        $(".Home-map-infos").removeClass("active");
      });
    $("#findDrive").on("submit", function(e) {
      e.preventDefault();
      const addr = $(this)
        .find("input")
        .val();
      if (addr) {
        map
          .geocode(addr)
          .then(map.findNearest)
          .catch(console.error);
      }
    });
  });
};



// WEBPACK FOOTER //
// ./assets/src/js/modules/MapHome.js